<div class="card">
  <div class="card-content">
    <h5>{{ titulo }}</h5>
    <span>{{ subtitulo }}</span>
  </div>
  <div class="imagen-wrapper">
    <div class="icon" [innerHTML]="imagen" [ngClass]="'icon-' + colorIcon"></div>
    <span class="overlay-text">{{percentage}}%</span>
  </div>
</div>

